// SPDX-License-Identifier: AGPL-3.0-or-later

import {ConfirmModal} from '@app/features/app/components/dialogs/ConfirmModal';
import type {User} from '@app/features/user/models/User';
import {plural} from '@lingui/core/macro';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';

interface MaxGuildsModalProps {
	user: User;
}
export const MaxGuildsModal = observer(({user}: MaxGuildsModalProps) => {
	const {t} = useLingui();
	const maxGuilds = user.maxGuilds;
	return (
		<ConfirmModal
			title={t`Too Many Communities`}
			description={plural(
				{count: maxGuilds},
				{
					one: "You've reached the maximum number of communities you can join (# community). Please leave a community before joining another one.",
					other:
						"You've reached the maximum number of communities you can join (# communities). Please leave a community before joining another one.",
				},
			)}
			primaryText={t`Understood`}
			onPrimary={() => {}}
			secondaryText={false}
			hideCloseButton
		/>
	);
});
